import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Focusable } from 'shared/models/focus/focus.model';

@Component({
  selector: 'app-navbar-status-dropdown-item',
  templateUrl: './navbar-status-dropdown-item.component.html',
  styleUrls: ['./navbar-status-dropdown-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarStatusDropdownItemComponent implements Focusable {
  @ViewChild('dropdownButton')
  private dropdownButton: ElementRef<HTMLElement>;

  @Input()
  name: string;
  @Input()
  inactive?: boolean;
  @Input()
  selected?: boolean;
  @Input()
  available?: boolean;
  @Input()
  away?: boolean;
  @Input()
  isFocusable?: boolean;
  @Output()
  readonly select = new EventEmitter<void>();

  onItemSelect() {
    if (!this.inactive && !this.selected) {
      this.select.emit();
    }
  }

  focus(): void {
    this.dropdownButton.nativeElement.focus();
  }

  get dropdownButtonTabIndex(): number {
    return this.isFocusable ? 0 : -1;
  }
}
